import { VerificationMethod } from '@/interfaces/totp';
import { User } from '@/interfaces/user';

export const getVerificationDescription = (
  verificationMethod: VerificationMethod,
  currentUser: User | null,
  t: (key: string, options?: any) => any
) => {
  switch (verificationMethod) {
    case VerificationMethod.BACKUP:
      return t('totp.backupCodeDesc');
    case VerificationMethod.EMAIL:
      return t('verification.verificationCodeDescription', { number: currentUser?.email });
    case VerificationMethod.SMS:
      return t('verification.verificationCodeDescription', { number: currentUser?.phone });
    default:
      return t('totp.verifyCodeDesc');
  }
};

export const getVerificationTitle = (verificationMethod: VerificationMethod, t: (key: string) => any) => {
  return verificationMethod === VerificationMethod.EMAIL || verificationMethod === VerificationMethod.SMS
    ? t('verification.verificationCode')
    : t('totp.verifyCodeTitle');
};

export const getInputLabel = (verificationMethod: VerificationMethod, source: string, t: (key: string) => any) => {
  if (verificationMethod === VerificationMethod.BACKUP) {
    return t('totp.backupCodeLabel');
  }
  return source === 'login-verify' ? t('verification.verificationCode') : t('totp.verificationCode');
};

export const getInputPlaceholder = (verificationMethod: VerificationMethod, t: (key: string) => any) => {
  return verificationMethod === VerificationMethod.BACKUP ? t('totp.backupCodePlaceholder') : t('general.sixDigitCode');
};

const ENCRYPTION_KEY = 'totp-backup-codes';

export const encryptData = (data: any): string => {
  try {
    const jsonString = JSON.stringify(data);
    return btoa(unescape(encodeURIComponent(jsonString + ENCRYPTION_KEY)));
  } catch {
    return '';
  }
};

export const decryptData = (encryptedData: string): any => {
  try {
    const decoded = decodeURIComponent(escape(atob(encryptedData)));
    const jsonString = decoded.replace(ENCRYPTION_KEY, '');
    return JSON.parse(jsonString);
  } catch {
    return null;
  }
};
